import React, { useEffect, useState } from "react";
import { getfaq_fun } from "../api/Pageapi";
import { Shimmer } from "react-shimmer";
import AOS from "aos";

export default function FAQ({ scheme_slug = null, setting_data }) {
  const [faqdata, setfaqdata] = useState([]);
  const [Isloading, setIsloading] = useState(true);
  const [isOpen,setIsOpen] = useState(false)



    const toggleDropdown = () => setIsOpen((prev) => !prev);

  const FAq_List = (id) => {
    setIsloading(true);

    getfaq_fun(id)
      .then((response) => {
        setfaqdata(response?.data);
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(false);
      });
  };

  useEffect(() => {
    const schemeMap = {
      saving_plan: 1,
      digital_plan: 2,
      gold_plant: 3,
    };

    // Default to 1 if scheme_slug is not found in the map
    const schemeId = schemeMap[scheme_slug] || null;
    FAq_List(schemeId);
  }, [scheme_slug]); // Add sch

  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  }, []);

  return (
    <>
      {faqdata?.length > 0 && (
        <div className="gaq-B">
          <div className="container">
            <div className="d-flex justify-content-center w-100 text-center titsksd mb-4">
              <div data-aos="fade-right">
                <img src="/assets/images/shpas.png" />
                <div className="d-flex justify-content-center align-items-center gap-3 " onClick={toggleDropdown} style={{ cursor: "pointer" }}>
                  <h2 className="fw-bold">Frequently Asked Questions</h2>
                  <span
                    style={{
                      fontSize: "0.9em",
                      userSelect: "none",
                      marginBottom:5,
                      // display: "inline-block",
                      transition: "transform 0.3s ease",
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                      // marginLeft: 9,
                      color: "  #ffffff"
                    }}
                  >
                    ▼
                  </span>
                </div>
              </div>
            </div>

           {isOpen &&  <div className="accordion row" id="accordionPanelsStayOpenExample">
              <div data-aos="fade-left">
                {!setting_data[0] ? (
                  <>
                    <ul
                      className="nav nav-pills  scheme-qus mb-5 justify-content-center"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item faq" role="presentation">
                        <Shimmer className="" width={210} height={50} />
                      </li>

                      <li className="nav-item faq " role="presentation">
                        <Shimmer className="" width={210} height={50} />
                      </li>

                      <li className="nav-item faq " role="presentation">
                        <Shimmer className="" width={210} height={50} />
                      </li>
                    </ul>
                  </>
                ) : (
                  <>
                    {scheme_slug === "saving_plan" && scheme_slug == null ? (
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active schemebtn"
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                          onClick={() => {
                            FAq_List(1);
                          }}
                        >
                          {setting_data
                            ? setting_data[0]?.saving_plan
                            : "Loading..."}
                        </button>
                      </li>
                    ) : null}

                    {scheme_slug === "digital_plan" && scheme_slug == null ? (
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link schemebtn"
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-profile"
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                          onClick={() => {
                            FAq_List(2);
                          }}
                        >
                          {setting_data
                            ? setting_data[0]?.digital_plan
                            : "Loading..."}
                        </button>
                      </li>
                    ) : null}

                    {scheme_slug === "gold_plant" && scheme_slug == null ? (
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link schemebtn"
                          id="pills-contact-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-contact"
                          type="button"
                          role="tab"
                          aria-controls="pills-contact"
                          aria-selected="false"
                          onClick={() => {
                            FAq_List(3);
                          }}
                        >
                          {setting_data
                            ? setting_data[0]?.gold_plant
                            : "Loading..."}
                        </button>
                      </li>
                    ) : null}
                    {/* </ul> */}
                  </>
                )}
              </div>
              {/* <div data-aos="fade-up">
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div className="row">
                      {Isloading
                        ? Array.from({ length: 6 }).map((_, i) => {
                            return (

                              <div className="col-md-6 col-sm-12 mb-3" key={i}>
                                <div className="accordion-item ">
                                  <h2 className="accordion-header">
                                    <button
                                      className="accordion-button"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#${i}`}
                                      aria-expanded="false"
                                      aria-controls="panelsStayOpen-collapseOne"
                                    >
                                      <Shimmer
                                        height={20}
                                        width={350}
                                        className="rounded "
                                      />
                                    </button>
                                  </h2>
                                  <div
                                    id={i}
                                    className="accordion-collapse collapse"
                                  >
                                    <div className="accordion-body">
                                      <p className="four_line mb-2">
                                        <Shimmer
                                          height={10}
                                          width={350}
                                          className="rounded "
                                        />
                                      </p>
                                      <p className="four_line mb-2">
                                        <Shimmer
                                          height={10}
                                          width={350}
                                          className="rounded "
                                        />
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        : faqdata
                        ? faqdata.map((r, i) => {
                            return (
                              <>
                                <div
                                  className="col-md-6 col-sm-12 mb-3"
                                  key={i}
                                >


                                  <div className="accordion" id="accordionExample">
                                    <div className="accordion-item">
                                      <h2
                                        className="accordion-header"
                                        id="headingOne"
                                      >
                                        <button
                                          className="accordion-button collapsed"
                                          type="button"
                                          data-bs-toggle="collapse"
                                          data-bs-target="#collapseOne"
                                          aria-expanded="false"
                                          aria-controls="collapseOne"
                                        >
                                          Accordion Item #1
                                        </button>
                                      </h2>
                                      <div
                                        id="collapseOne"
                                        className="accordion-collapse collapse"
                                        aria-labelledby="headingOne"
                                        data-bs-parent="#accordionExample"
                                      >
                                        <div className="accordion-body">
                                          <strong>
                                            This is the first item's accordion
                                            body.
                                          </strong>{" "}
                                          It is hidden by default...
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            );
                          })
                        : ""}
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div className="row">
                      {Isloading
                        ? Array.from({ length: 6 }).map((_, i) => {
                            return (
                              // <div className='col-sm-6 mb-3' key={i}>
                              //     <div><Shimmer height={64} className='rounded w-100' /></div>
                              // </div>
                              <div className="col-md-6 col-sm-12 mb-3" key={i}>
                                <div className="accordion-item ">
                                  <h2 className="accordion-header">
                                    <button
                                      className="accordion-button"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#${i}`}
                                      aria-expanded="false"
                                      aria-controls="panelsStayOpen-collapseOne"
                                    >
                                      <Shimmer
                                        height={20}
                                        width={350}
                                        className="rounded "
                                      />
                                    </button>
                                  </h2>
                                  <div
                                    id={i}
                                    className="accordion-collapse collapse"
                                  >
                                    <div className="accordion-body">
                                      <p className="four_line mb-2">
                                        <Shimmer
                                          height={10}
                                          width={350}
                                          className="rounded "
                                        />
                                      </p>
                                      <p className="four_line mb-2">
                                        <Shimmer
                                          height={10}
                                          width={350}
                                          className="rounded "
                                        />
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        : faqdata
                        ? faqdata.map((r, i) => {
                            return (
                              <>
                                <div
                                  className="col-md-6 col-sm-12 mb-3"
                                  key={i}
                                >
                                  <div className="accordion-item ">
                                    <h2 className="accordion-header">
                                      <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#${r.id}`}
                                        aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseOne"
                                      >
                                        {r.title}
                                      </button>
                                    </h2>
                                    <div
                                      id={r.id}
                                      className="accordion-collapse collapse"
                                    >
                                      <div className="accordion-body">
                                        <p className="four_line">
                                          {r.description}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            );
                          })
                        : ""}
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="pills-contact"
                    role="tabpanel"
                    aria-labelledby="pills-contact-tab"
                  >
                    <div className="row">
                      {Isloading
                        ? Array.from({ length: 6 }).map((_, i) => {
                            return (
                              <div className="col-md-6 col-sm-12 mb-3" key={i}>
                                <div className="accordion-item ">
                                  <h2 className="accordion-header">
                                    <button
                                      className="accordion-button"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#${i}`}
                                      aria-expanded="false"
                                      aria-controls="panelsStayOpen-collapseOne"
                                    >
                                      <Shimmer
                                        height={20}
                                        width={350}
                                        className="rounded "
                                      />
                                    </button>
                                  </h2>
                                  <div
                                    id={i}
                                    className="accordion-collapse collapse"
                                  >
                                    <div className="accordion-body">
                                      <p className="four_line mb-2">
                                        <Shimmer
                                          height={10}
                                          width={350}
                                          className="rounded "
                                        />
                                      </p>
                                      <p className="four_line mb-2">
                                        <Shimmer
                                          height={10}
                                          width={350}
                                          className="rounded "
                                        />
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        : faqdata
                        ? faqdata.map((r, i) => {
                            return (
                              <>
                                <div
                                  className="col-md-6 col-sm-12 mb-3"
                                  key={i}
                                >
                                  <div className="accordion-item ">
                                    <h2 className="accordion-header">
                                      <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#${r.id}`}
                                        aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseOne"
                                      >
                                        {r.title}
                                      </button>
                                    </h2>
                                    <div
                                      id={r.id}
                                      className="accordion-collapse collapse"
                                    >
                                      <div className="accordion-body">
                                        <p className="four_line">
                                          {r.description}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            );
                          })
                        : ""}
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="accordion" id="accordionExample">
                <div className="row">
                  {Isloading
                    ? Array.from({ length: 6 }).map((_, i) => (
                      <div className="col-md-6 col-sm-12 mb-3" key={i}>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id={`heading-shimmer-${i}`}>
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse-shimmer-${i}`}
                              aria-expanded="false"
                              aria-controls={`collapse-shimmer-${i}`}
                            >
                              <Shimmer height={20} width={350} className="rounded" />
                            </button>
                          </h2>
                          <div
                            id={`collapse-shimmer-${i}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`heading-shimmer-${i}`}
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <p className="four_line mb-2">
                                <Shimmer height={10} width={350} className="rounded" />
                              </p>
                              <p className="four_line mb-2">
                                <Shimmer height={10} width={350} className="rounded" />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                    : faqdata && faqdata.length > 0
                      ? faqdata.map((r, i) => (
                        <div className="col-md-6 col-sm-12 mb-3" key={r.id || i}>
                          <div className="accordion-item">
                            <h2
                              className="accordion-header"
                              id={`heading-${r.id || i}`}
                            >
                              <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse-${r.id || i}`}
                                aria-expanded="false"
                                aria-controls={`collapse-${r.id || i}`}
                              >
                                {r.title}
                              </button>
                            </h2>
                            <div
                              id={`collapse-${r.id || i}`}
                              className="accordion-collapse collapse"
                              aria-labelledby={`heading-${r.id || i}`}
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                <p className="four_line">{r.description}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                      : "No FAQs available."}
                </div>
              </div>

            </div>}
          </div>
        </div>
      )}
    </>
  );
}
